export const getRemindMeQueryKey = (
  userId?: MaybeRefOrGetter<string | undefined>
) => ['notification-subscribed-variant-ids', userId]
